// extracted by mini-css-extract-plugin
export var bounce = "_hr-1";
export var generatingText = "_hr-6";
export var lightning = "_hr-4";
export var popup = "_hr-5";
export var progressBar = "_hr-7";
export var progressFill = "_hr-8";
export var progressShimmer = "_hr-9";
export var progressText = "_hr-a";
export var shimmer = "_hr-3";
export var uploadIcon = "_hr-0";
export var uploadingText = "_hr-2";